import { render, staticRenderFns } from "./IconRewardExplore.vue?vue&type=template&id=4f13b47d"
import script from "./IconRewardExplore.vue?vue&type=script&lang=js"
export * from "./IconRewardExplore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports